import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-[15px] font-semibold transition-all duration-300 disabled:pointer-events-none disabled:opacity-50 cursor-pointer select-none outline-none border-none",
  {
    variants: {
      variant: {
        default:
          "bg-gray-900 text-white shadow-sm hover:bg-brand-teal",
        brand:
          "bg-brand-teal text-white shadow-[0_4px_16px_rgba(27,102,122,0.24)] hover:bg-[#155568] hover:shadow-[0_6px_20px_rgba(27,102,122,0.32)] hover:-translate-y-0.5",
        destructive:
          "bg-gradient-to-r from-red-500 to-red-600 text-white shadow-md hover:shadow-lg",
        outline:
          "border-2 border-brand-orange bg-transparent text-brand-orange hover:bg-brand-orange hover:text-white shadow-none hover:shadow-md",
        secondary:
          "bg-gray-100 text-gray-900 shadow-sm hover:bg-gray-200",
        ghost: "hover:bg-gray-100 hover:text-gray-900",
        link: "text-accent underline-offset-4 hover:underline",
        accent:
          "bg-gradient-to-r from-brand-orange to-amber-500 text-white shadow-[0_4px_16px_rgba(245,166,35,0.3)] hover:shadow-[0_6px_24px_rgba(245,166,35,0.45)] hover:-translate-y-0.5 active:translate-y-0",
      },
      size: {
        default: "h-10 rounded-[10px] px-6 py-2.5",
        sm: "h-8 rounded-full px-3 text-xs",
        lg: "h-12 rounded-full px-8 text-base",
        icon: "h-10 w-10 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
